import { AGG_GOAL_PAGE, AGG_GOAL_PATH_PATTERN } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute } from '@townsquare/router/route-types';

export const aggGoalRoute: SiteHomePageRoute = createSiteRoute({
	exact: true,
	name: AGG_GOAL_PAGE,
	path: AGG_GOAL_PATH_PATTERN,
	capabilities: ['goals_app:access'],
	subproduct: 'townsquare-goals',
	enableRestrictedFallback: true,
	featureGating: {
		gates: ['goal_types_m3_bundled_updates'],
		behavior: { type: 'enabled' },
	},
});
